/**
 * Supernova brand marks. Two files per variant instead of one: an <img> renders the SVG as
 * an isolated document, so `currentColor` inside it can't inherit the page's theme — the
 * light/dark variants have to be real files swapped by the `dark` class.
 *
 * Imported (not referenced from public/) so Vite hashes the filenames. A fixed path like
 * /logo.svg has no Cache-Control, so browsers cache it heuristically and keep serving the
 * previous logo after a rebrand until the user hard-refreshes.
 *
 * `wordmark` = mark + "SUPERNOVA" lettering (expanded sidebar, login).
 * `mark`     = symbol only (collapsed sidebar, where the lettering has no room).
 */
import wordmarkLight from '../assets/logo.svg'
import wordmarkDark from '../assets/logo-dark.svg'
import markLight from '../assets/logo-icon.svg'
import markDark from '../assets/logo-icon-dark.svg'

const SRC = {
  wordmark: { light: wordmarkLight, dark: wordmarkDark },
  mark: { light: markLight, dark: markDark },
} as const

export function BrandLogo({
  className = '',
  variant = 'wordmark',
}: {
  className?: string
  variant?: keyof typeof SRC
}) {
  const src = SRC[variant]
  return (
    <>
      <img src={src.light} alt="Supernova" className={`${className} dark:hidden`} />
      <img src={src.dark} alt="Supernova" className={`${className} hidden dark:block`} />
    </>
  )
}
